export default __webpack_public_path__ + "static/media/flag-fr.23afe17c.svg";